import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import {
  bundledResources,
  DEFAULT_LANGUAGE,
  getAppLanguage,
  getLanguages,
} from "../models/language";

export const configureI18n = (lng?: string) => {
  if (i18next.isInitialized) return;

  const { languages } = getLanguages();

  i18next.use(initReactI18next).init({
    load: "currentOnly",
    lng: lng ?? getAppLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: languages,
    defaultNS: "common",
    ns: ["common"],
    resources: bundledResources,
    keySeparator: "",
    nsSeparator: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
};
